<template>
    <td class="border border-gray-400 font-normal p-2 align-top transition" :class="class">
        <slot />
    </td>
</template>

<script>
export default {
    props: {
        class: {
            type: String,
        },
    },
}
</script>
